import { Toaster } from 'react-hot-toast'
import AppRoutes from './routes.jsx'
import ErrorBoundary from './components/common/ErrorBoundary'
import './styles/global.css'
import { FaceIOProvider } from './context/FaceIOContext'

function App() {
  return (
    <ErrorBoundary fullPage>
      <FaceIOProvider>
        <AppRoutes />
      </FaceIOProvider>
    </ErrorBoundary>
  )
}

export default App